/* unplugin-vue-components disabled */import script from "./TagsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagsView.vue?vue&type=script&setup=true&lang=ts"

import "./TagsView.vue?vue&type=style&index=0&id=fea67214&lang=scss&scoped=true"
import "./TagsView.vue?vue&type=style&index=1&id=fea67214&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fea67214"]])

export default __exports__